/**
 * @file 首页子模块
 * @author gaoxunchen
 */

import _ from 'lodash';
import React, { useState } from 'react';
import classnames from 'classnames';
import Icon from '@tencent/od-icon';

import './index.scoped.less';

interface AgencySelectProps {
  /* 标题 */
  title?: string;
  /* 头部信息，优先级高于title */
  header?: any;
  /* 内容信息 */
  children?: any;
  /* 类 */
  className?: string;
  /* 样式 */
  style?: Record<string, any>;
  /* 可以折叠 */
  canFold?: boolean;
}

const HomeItem: React.FC<AgencySelectProps> = (props) => {
  const { title, header, children, className, style = {}, canFold = false } = props;
  const [fold, setFold] = useState(false);

  const onClickHeader = () => {
    if (canFold) {
      setFold(!fold);
    }
  };

  return (
    <div
      className={classnames('home-item', className, {
        'can-fold': canFold,
        fold,
        unfold: !fold,
      })}
      style={style}
    >
      {header ? (
        <div
          className="home-item-header"
          onClick={onClickHeader}
        >
          {canFold ? (
            <Icon className="icon-fold" name="down-medium-outlined"/>
          ) : null}
          {header}
        </div>
      ) : null}
      {!header && title ? (
        <div
        className="home-item-header"
        onClick={onClickHeader}
        >
          {canFold ? (
            <Icon className="icon-fold" name="down-medium-outlined"/>
          ) : null}
          {header}
          <div className="title">
            {title}
          </div>
        </div>
      ) : null}
      <div className="home-item-body">
        {children}
      </div>
    </div>
  );
};

export default HomeItem;

// 一行包多个HomeItem
export const HomeRowWrapper: React.FC<AgencySelectProps> = (props) => {
  const { children } = props;

  return (
    <div className={'home-row-wrapper'}>
      {children }
    </div>
  );
};
